<template>
  <div>
    <!-- QR Scanner Dialog -->
    <v-dialog
      v-model="scanner"
      max-width="500"
      persistent
      class="scanner-dialog"
    >
      <v-card class="scanner-card">
        <!-- Header -->
        <v-card-title class="scanner-header">
          <div class="header-logo">
            <LogoWhite></LogoWhite>
          </div>
        </v-card-title>

        <!-- Content -->
        <v-card-text class="scanner-content">
          <!-- Event Selection -->
          <div class="scanner-section">
            <div class="section-label">
              <v-icon size="18" class="mr-2">mdi-calendar</v-icon>
              <span>Select Event</span>
            </div>
            <v-select
              v-model="selectedEvent"
              :items="eventsOptions"
              item-title="name"
              item-value="id"
              variant="outlined"
              density="comfortable"
              class="event-select"
              hide-details
            >
              <template v-slot:selection="{ item }">
                <span class="select-text">{{ item.raw.name }} - {{ item.raw.location }}</span>
              </template>
            </v-select>
          </div>

          <!-- Camera Selection -->
          <div class="scanner-section">
            <div class="section-label">
              <v-icon size="18" class="mr-2">mdi-camera</v-icon>
              <span>Select Camera</span>
            </div>
            <v-select
              v-model="selectedConstraints"
              :items="constraintOptions"
              item-title="label"
              item-value="constraints"
              variant="outlined"
              density="comfortable"
              class="camera-select"
              hide-details
              return-object
            >
              <template v-slot:selection="{ item }">
                <span class="select-text">{{ item.raw.label }}</span>
              </template>
            </v-select>
          </div>

          <v-divider class="my-4" style="opacity: 0.2;"></v-divider>

          <!-- QR Scanner Title -->
          <div class="scanner-title">
            <v-icon class="mr-2">mdi-qrcode-scan</v-icon>
            <span>Scan Ticket QR Code</span>
          </div>

          <!-- QR Code Stream -->
          <div class="qr-stream-wrapper">
            <qrcode-stream
              :paused="paused"
              :constraints="selectedConstraints"
              :track="paintBoundingBox"
              @error="onError"
              @detect="onDetect"
              @camera-on="onCameraReady"
            />
          </div>

          <!-- Error Message -->
          <v-alert
            v-if="errorscann"
            type="error"
            variant="outlined"
            class="scanner-alert mt-3"
            icon="mdi-alert-circle"
          >
            {{ errorscann }}
          </v-alert>

          <!-- Success Message -->
          <v-alert
            v-if="resultscann2 && !validationongoing"
            type="success"
            variant="outlined"
            class="scanner-alert mt-3"
            icon="mdi-check-circle"
          >
            Ticket found: {{ resultscann2 }}
          </v-alert>

          <!-- Validation Warning -->
          <v-alert
            v-if="scannedOK && !validEvent"
            type="warning"
            variant="outlined"
            class="scanner-alert mt-3"
            icon="mdi-alert"
          >
            Select valid event before validation
          </v-alert>

          <!-- Validation Result -->
          <div v-if="validationongoing" class="validation-result">
            <div class="result-icon-wrapper">
              <v-icon
                v-if="validationresult"
                size="64"
                color="success"
                class="result-icon"
              >
                mdi-check-circle
              </v-icon>
              <v-icon
                v-else
                size="64"
                color="error"
                class="result-icon"
              >
                mdi-close-circle
              </v-icon>
            </div>
            <div class="result-content">
              <div v-if="validationresult" class="result-title success">
                Ticket Validated Successfully
              </div>
              <div v-else-if="ticketused" class="result-title error">
                Ticket Already Used
              </div>
              <div v-else class="result-title error">
                Validation Failed
              </div>
              <div v-if="ticketinfo" class="result-info">
                {{ ticketinfo }}
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div v-if="scannedOK && validEvent && !validationongoing" class="scanner-actions">
            <v-btn
              v-if="!validationresult && !ticketused"
              variant="outlined"
              color="success"
              prepend-icon="mdi-check"
              @click="validateTicket(resultscann)"
              class="action-btn validate-btn"
            >
              Validate Ticket
            </v-btn>
            <v-btn
              v-if="!validationresult"
              variant="outlined"
              color="white"
              prepend-icon="mdi-ticket-confirmation"
              @click="checkTicket(resultscann)"
              class="action-btn check-btn"
            >
              Check Details
            </v-btn>
          </div>
        </v-card-text>

        <!-- Footer Actions -->
        <v-card-actions class="scanner-footer">
          <v-btn
            variant="text"
            color="white"
            @click="closeDialogScanned"
            class="footer-btn"
          >
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            color="white"
            prepend-icon="mdi-refresh"
            @click="rescan"
            class="footer-btn rescan-btn"
          >
            Re-scan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Main Content -->
    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div class="overlay-grey-web">
              <!-- Header Section -->
              <div class="ticketing-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-ticket-account</v-icon>
                  <h1 class="header-title">Event Ticketing</h1>
                </div>
                <p class="header-subtitle">
                  Manage your events, scan tickets, and track attendees
                </p>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Quick Actions -->
              <div class="quick-actions-section">
                <v-btn
                  variant="outlined"
                  size="large"
                  prepend-icon="mdi-calendar-plus"
                  @click="handleClickMenu('createEvent')"
                  class="quick-action-btn create-event-btn"
                >
                  Create Event
                </v-btn>
                <v-btn
                  variant="outlined"
                  size="large"
                  prepend-icon="mdi-qrcode-scan"
                  @click="openScanner()"
                  class="quick-action-btn scan-btn"
                >
                  Scan Ticket
                </v-btn>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Incoming Events Section -->
              <div class="ticketing-section">
                <h2 class="section-title">
                  <v-icon left>mdi-calendar-clock</v-icon>
                  Upcoming Events
                </h2>

                <div class="events-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="64" color="grey">mdi-calendar-blank</v-icon>
                  </div>
                  <h3 class="empty-title">No Upcoming Events</h3>
                  <p class="empty-subtitle">
                    Create your first event to start selling tickets
                  </p>
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-calendar-plus"
                    @click="handleClickMenu('createEvent')"
                    class="mt-4"
                  >
                    Create Event
                  </v-btn>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- All Events Section -->
              <div class="ticketing-section">
                <h2 class="section-title">
                  <v-icon left>mdi-format-list-bulleted</v-icon>
                  All Your Events
                </h2>

                <v-text-field
                  v-model="searchQueryEvent"
                  placeholder="Search events..."
                  prepend-inner-icon="mdi-magnify"
                  density="comfortable"
                  hide-details
                  clearable
                  class="search-field mb-4"
                  variant="outlined"
                  disabled
                ></v-text-field>

                <div class="events-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="64" color="grey">mdi-ticket-outline</v-icon>
                  </div>
                  <h3 class="empty-title">No Events Created</h3>
                  <p class="empty-subtitle">
                    Start by creating your first event
                  </p>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Participants Section -->
              <div class="participants-section">
                <div class="participants-sidebar">
                  <h3 class="sidebar-title">
                    Participants
                  </h3>
                  <v-alert
                    type="info"
                    variant="outlined"
                    icon="mdi-information"
                    class="mb-3"
                  >
                    Select an event to view participants
                  </v-alert>
                  <v-text-field
                    v-model="searchQuery"
                    placeholder="Search participants..."
                    prepend-inner-icon="mdi-magnify"
                    density="comfortable"
                    hide-details
                    clearable
                    class="search-field mb-3"
                    variant="outlined"
                    disabled
                  ></v-text-field>
                  <div class="participants-empty">
                    <v-icon size="48" color="grey">mdi-account-group-outline</v-icon>
                    <p>No participants</p>
                  </div>
                </div>

                <div class="participants-content">
                  <div class="content-empty-state">
                    <v-icon size="80" color="grey">mdi-account-search</v-icon>
                    <h3>No Participant Selected</h3>
                    <p>Select a participant from the list to view details</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-row
          :style="(this.isMobileXs || this.isMobilePlayer3) ? 'padding-top:170px!important' : 'padding-top:123px!important'"
        ></v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import LogoWhite from '../components/logo_white.vue';
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'Ticketing',

  components: {
    LogoWhite,
    QrcodeStream,
  },
  data: () => ({
    navbar: false,
    user: null,
    searchQuery: "",
    searchQueryEvent: "",
    scanner: false,
    scannedOK: false,
    paused: false,

    errorscann: "",
    resultscann: "",
    resultscann2: "",
    validationresult: false,
    validationongoing: false,
    ticketused: false,
    ticketinfo: "",

    selectedEvent: 0,

    selectedConstraints: { facingMode: 'environment' },
    eventsOptions: [
      { name: 'No Event', location: "Unknown", id: 0 }
    ],
    defaultConstraintOptions: [
      { label: 'Rear camera', constraints: { facingMode: 'environment' } },
      { label: 'Front camera', constraints: { facingMode: 'user' } }
    ],
    constraintOptions: [
      { label: 'Rear camera', constraints: { facingMode: 'environment' } },
      { label: 'Front camera', constraints: { facingMode: 'user' } }
    ],
  }),
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  watch: {
    '$store.state.user': function () {
      this.user = this.$store.getters.getUserData;
    },
  },
  computed: {
    validEvent() {
      if (this.selectedEvent === 0) {
        return false;
      } else {
        return true;
      }
    },
    isfullScreen() {
      if (this.isMobile && this.isMobileXs) {
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
      return this.$store.getters.getUserData != null
    },
    isDesktop() {
      if (!this.navbar) {
        return true;
      } else {
        return false;
      }
    },
    getGextPanel() {
      if (this.navbar) {
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },
  },
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;

      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    }
  },
  methods: {
    validateTicket(ticket) {
      if (this.scannedOK) {
        this.notify("Soon!");
      } else {
        this.notifyError("Error validating ticket. Please try again later.");
      }
    },
    checkTicket(ticket) {
      window.location.href = 'https://tickets.muzible.com/ticket/' + ticket;
    },
    async onCameraReady() {
      const devices = await navigator.mediaDevices.enumerateDevices()
      const videoDevices = devices.filter(({ kind }) => kind === 'videoinput')

      this.constraintOptions = [
        ...this.defaultConstraintOptions,
        ...videoDevices.map(({ deviceId, label }) => ({
          label: `${label}`,
          constraints: { deviceId }
        }))
      ]

      this.errorscann = '';
      this.validationresult = false;
      this.scannedOK = false;
      this.resultscann = '';
      this.resultscann2 = '';
      this.validationongoing = false;
      this.ticketused = false;
      this.ticketinfo = '';
    },
    onDetect(detectedCodes) {
      this.resultscann = JSON.stringify(detectedCodes.map((code) => code.rawValue))
      if (this.resultscann.includes("tickets.muzible.com")) {
        this.scannedOK = true;
        this.resultscann2 = "John Doe";
        this.validationongoing = false;
        this.ticketused = false;
        this.ticketinfo = "";
      } else {
        this.resultscann2 = "";
        this.scannedOK = false;
        this.validationongoing = false;
        this.ticketused = false;
        this.ticketinfo = "";
      }
    },
    onError(err) {
      this.errorscann = `[${err.name}]: `

      if (err.name === 'NotAllowedError') {
        this.errorscann += 'you need to grant camera access permission'
      } else if (err.name === 'NotFoundError') {
        this.errorscann += 'no camera on this device'
      } else if (err.name === 'NotSupportedError') {
        this.errorscann += 'secure context required (HTTPS, localhost)'
      } else if (err.name === 'NotReadableError') {
        this.errorscann += 'is the camera already in use?'
      } else if (err.name === 'OverconstrainedError') {
        this.errorscann += 'installed cameras are not suitable'
      } else if (err.name === 'StreamApiNotSupportedError') {
        this.errorscann += 'Stream API is not supported in this browser'
      } else if (err.name === 'InsecureContextError') {
        this.errorscann += 'Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.'
      } else {
        this.errorscann += err.message
      }
    },
    paintBoundingBox(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const {
          boundingBox: { x, y, width, height }
        } = detectedCode

        ctx.lineWidth = 4
        ctx.strokeStyle = '#4CAF50'
        ctx.strokeRect(x, y, width, height)
      }
    },
    closeDialogScanned() {
      this.scanner = false;
      this.resultscann = "";
      this.resultscann2 = "";
      this.errorscann = "";
      this.scannedOK = false;
      this.validationresult = false;
      this.validationongoing = false;
      this.ticketused = false;
      this.ticketinfo = "";
    },
    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms)
      })
    },
    async rescan() {
      this.resultscann = "";
      this.resultscann2 = "";
      this.errorscann = "";
      this.scannedOK = false;
      this.validationresult = false;
      this.validationongoing = false;
      this.paused = true;
      await this.timeout(10);
      this.paused = false;
      this.ticketused = false;
      this.ticketinfo = "";
    },
    openScanner() {
      this.scanner = true;
      this.resultscann = "";
      this.resultscann2 = "";
      this.errorscann = "";
      this.scannedOK = false;
      this.validationresult = false;
      this.validationongoing = false;
      this.ticketused = false;
      this.ticketinfo = "";
    },
    checkScreenSize() {
      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    handleClickMenu(link) {
      if (link === 'TryMuzE') {
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse') {
        window.location.href = 'https://verse.muzible.com/';
      } else if (link === 'createEvent') {
        window.location.href = 'https://tickets.muzible.com/events/create';
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Scanner Dialog Styles */
.scanner-dialog {
  :deep(.v-overlay__content) {
    border-radius: 16px;
  }
}

.scanner-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.98), rgba(18, 18, 18, 0.98)) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
  max-height: 90vh;
  overflow-y: auto;
}

.scanner-header {
  background: rgba(0, 0, 0, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-logo {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.header-logo:hover {
  transform: scale(1.05);
}

.scanner-content {
  padding: 24px !important;
  color: white;
}

.scanner-section {
  margin-bottom: 20px;
}

.section-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.event-select,
.camera-select {
  font-family: "Darker Grotesque", sans-serif !important;
}

:deep(.event-select .v-field),
:deep(.camera-select .v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

:deep(.event-select .v-field:hover),
:deep(.camera-select .v-field:hover) {
  border-color: rgba(255, 255, 255, 0.4) !important;
}

:deep(.event-select .v-field--focused),
:deep(.camera-select .v-field--focused) {
  border-color: rgba(255, 255, 255, 0.6) !important;
}

.select-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: white;
  font-weight: 500;
}

.scanner-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: white;
  margin-bottom: 16px;
}

.qr-stream-wrapper {
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: black;
}

.scanner-alert {
  border-radius: 8px !important;
  font-family: "Darker Grotesque", sans-serif !important;
  
  :deep(.v-alert__content) {
    color: white !important;
    font-size: 14px !important;
  }
}

.validation-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  margin-top: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.result-icon-wrapper {
  margin-bottom: 16px;
  animation: scaleIn 0.4s ease-out;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.result-content {
  text-align: center;
}

.result-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 8px;
}

.result-title.success {
  color: #4CAF50;
}

.result-title.error {
  color: #f44336;
}

.result-info {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
}

.scanner-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 20px;
}

.action-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 0 24px !important;
  height: 44px !important;
  border-radius: 8px !important;
}

.validate-btn {
  border-color: rgba(76, 175, 80, 0.5) !important;
}

.validate-btn:hover {
  background: rgba(76, 175, 80, 0.1) !important;
  border-color: rgba(76, 175, 80, 0.8) !important;
}

.check-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.scanner-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.3);
}

.footer-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
}

.rescan-btn {
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.rescan-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Main Page Styles */
.ticketing-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.header-icon {
  font-size: 48px !important;
  color: white;
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.header-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.5;
}

.quick-actions-section {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 32px;
}

.quick-action-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  padding: 0 32px !important;
}

.quick-action-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.create-event-btn:hover {
  background: rgba(76, 175, 80, 0.1) !important;
  border-color: rgba(76, 175, 80, 0.6) !important;
}

.scan-btn:hover {
  background: rgba(33, 150, 243, 0.1) !important;
  border-color: rgba(33, 150, 243, 0.6) !important;
}

.ticketing-section {
  margin-bottom: 40px;
}

.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-field {
  font-family: "Darker Grotesque", sans-serif !important;
}

:deep(.search-field .v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

:deep(.search-field .v-field:hover:not(.v-field--disabled)) {
  border-color: rgba(255, 255, 255, 0.4) !important;
}

:deep(.search-field .v-field--focused) {
  border-color: rgba(255, 255, 255, 0.6) !important;
}

:deep(.search-field .v-field__input) {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500;
}

:deep(.search-field.v-field--disabled .v-field) {
  opacity: 0.5;
}

.events-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 250px;
  padding: 40px 20px;
  text-align: center;
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
}

.empty-icon-wrapper {
  margin-bottom: 20px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.empty-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin-bottom: 8px;
}

.empty-subtitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 20px;
  max-width: 400px;
  line-height: 1.5;
}

.participants-section {
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 24px;
  min-height: 500px;
}

@media (max-width: 1024px) {
  .participants-section {
    grid-template-columns: 1fr;
  }
}

.participants-sidebar {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
}

.sidebar-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: white;
  margin-bottom: 16px;
}

.participants-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
}

.participants-empty p {
  margin-top: 12px;
  font-size: 14px;
}

.participants-content {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.content-empty-state h3 {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: white;
  margin: 16px 0 8px 0;
}

.content-empty-state p {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ticketing-section,
.participants-section {
  animation: slideIn 0.4s ease forwards;
}

/* Override Vuetify */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-alert) {
  font-family: "Darker Grotesque", sans-serif !important;
}
</style>